import parques_municipais from "../../../mockups/paineis/Frame 71_transparente.png"

export default function ParquesMunicipais({ getImagem }) {
  return (
    <div className="px-16 py-10 flex justify-center">
      {/* <div className="border border-grayLight rounded-3xl overflow-hidden">
        <header className="bg-blue text-white py-6 text-center">
          <h1 className="text-4xl font-bold">Parques Municipais</h1>
        </header>

        <div className="p-10">
          <div className="grid grid-cols-3 gap-10">
            CARD 1
            <div className="flex flex-col items-center text-center">
              <img
                src={getImagem(1)}
                className="h-[160px] object-cover rounded-3xl"
                alt="imagem de um parque"
              />

              <div className="mt-5 flex flex-col items-start text-left">
                <h1 className="text-5xl font-bold text-deepBlue">+254 mi</h1>
                <p className="text-2xl font-semibold text-deepBlue">
                  visitas nos parques
                </p>
                <p className="text-[20px] text-greenDark">(desde 2021)</p>
              </div>
            </div>

            CARD 2
            <div className="flex flex-col items-center text-center">
              <img
                src={getImagem(2)}
                className="h-[160px] object-cover rounded-3xl"
                alt="imagem de um parque"
              />

              <div className="mt-5 flex flex-col gap-3 items-start text-left">
                <div className="flex items-end gap-3">
                  <h1 className="text-6xl font-bold text-deepBlue">62</h1>
                  <p className="text-2xl font-semibold text-deepBlue leading-tight">
                    parques <br />
                    requalificados
                  </p>
                </div>

                <p className="text-[20px] text-greenDark">(desde 2021)</p>
              </div>
            </div>
            CARD 3
            <div className="flex flex-col items-center text-center">
              <img
                src={getImagem(3)}
                className="h-[160px] object-cover rounded-3xl"
                alt="imagem de um parque"
              />

              <div className="mt-5 flex flex-col gap-3 items-start text-left">
                <div className="flex items-end gap-3">
                  <h1 className="text-6xl font-bold text-deepBlue">15</h1>
                  <p className="text-2xl font-semibold text-deepBlue leading-tight">
                    parques <br />
                    inaugurados
                  </p>
                </div>

                <p className="text-[20px] text-greenDark">(desde 2021)</p>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <img src={parques_municipais} alt="" />
    </div>
  );
}
